import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import type { KenhBanHang, KenhBanHangInput } from '@/types/schemas/kenh-ban-hang.type';
import { formSchema, type FormValues, initialValues } from '../schemas';
import { useSearchFieldStates } from '../hooks';
import { FormMode } from '@/types/form';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: KenhBanHangInput) => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: KenhBanHang | null;
  selectedObj?: KenhBanHang | null;
  isCopyMode?: boolean;
}

function FormDialog({
  mode,
  open,
  onClose,
  onSubmit,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  selectedObj,
  isCopyMode = false
}: FormDialogProps) {
  // Initialize search field states with selectedObj for edit/view/copy modes, null for add mode
  const {
    nguonDon,
    setNguonDon,
    hinhThucThanhToan,
    setHinhThucThanhToan,
    phuongThucThanhToan,
    setPhuongThucThanhToan
  } = useSearchFieldStates(mode === 'add' && !isCopyMode ? null : selectedObj);
  const handleSubmit = async (data: FormValues) => {
    await onSubmit({
      ...data,
      ma_nguondon: nguonDon?.uuid || null,
      ma_httt: hinhThucThanhToan?.uuid || null,
      ma_pttt: phuongThucThanhToan?.uuid || null
    });
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Thêm kênh bán hàng' : mode === 'edit' ? 'Sửa kênh bán hàng' : 'Xem kênh bán hàng'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData as Partial<FormValues> | null | undefined) || initialValues}
          className='w-[90%] min-w-[43vw]'
          headerFields={
            <BasicInfo
              mode={mode}
              nguonDon={nguonDon}
              hinhThucThanhToan={hinhThucThanhToan}
              phuongThucThanhToan={phuongThucThanhToan}
              setNguonDon={setNguonDon}
              setHinhThucThanhToan={setHinhThucThanhToan}
              setPhuongThucThanhToan={setPhuongThucThanhToan}
            />
          }
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
